/* Applications list — inline code pill matching the design `.codepill`
 * (inline-flex, 2px 7px, 12px mono on grey-lightest). The shared
 * `CodeBlock` primitive is block-level, so table cells use this instead. */
.codepill {
  display: inline-block;
  background: var(--color-grey-lightest);
  padding: 2px 7px;
  border-radius: 5px;
  font-family: ui-monospace, "SF Mono", Menlo, monospace;
  font-size: var(--font-size-s);
  color: var(--color-text);
}
